import { useEffect } from "react";

const SELECTABLE =
  'input, textarea, select, [contenteditable="true"], .allow-select';

function isSelectableTarget(target) {
  return target instanceof Element && Boolean(target.closest(SELECTABLE));
}

function blockUnlessSelectable(handler) {
  return (event) => {
    if (isSelectableTarget(event.target)) return;
    event.preventDefault();
  };
}

function blockKeyboardCopy(event) {
  if (isSelectableTarget(event.target)) return;

  const key = event.key?.toLowerCase();
  const mod = event.ctrlKey || event.metaKey;
  if (!mod || !key) return;

  if (key === "c" || key === "x" || key === "a" || key === "u" || key === "s" || key === "p") {
    event.preventDefault();
  }
}

export default function useCopyProtection() {
  useEffect(() => {
    const onContextMenu = blockUnlessSelectable((e) => e.preventDefault());
    const onCopy = blockUnlessSelectable((e) => e.preventDefault());
    const onCut = blockUnlessSelectable((e) => e.preventDefault());
    const onSelectStart = blockUnlessSelectable((e) => e.preventDefault());
    const onDragStart = (event) => {
      if (event.target instanceof HTMLImageElement && !isSelectableTarget(event.target)) {
        event.preventDefault();
      }
    };

    document.addEventListener("contextmenu", onContextMenu);
    document.addEventListener("copy", onCopy);
    document.addEventListener("cut", onCut);
    document.addEventListener("selectstart", onSelectStart);
    document.addEventListener("dragstart", onDragStart);
    document.addEventListener("keydown", blockKeyboardCopy);

    return () => {
      document.removeEventListener("contextmenu", onContextMenu);
      document.removeEventListener("copy", onCopy);
      document.removeEventListener("cut", onCut);
      document.removeEventListener("selectstart", onSelectStart);
      document.removeEventListener("dragstart", onDragStart);
      document.removeEventListener("keydown", blockKeyboardCopy);
    };
  }, []);
}
